// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Keyboard__wrapper___ynzOx","keyboard":"Keyboard__keyboard___1dLxs","key":"Keyboard__key___1SNfa","large":"Keyboard__large___3a2E3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Keyboard/Keyboard.css
// module id = 854
// module chunks = 0